import { AssetCtx, Content, M2cIdentifiers, TGCTAs } from "@swiggy-private/cart-types";

export enum States {
    PRE_STATE = "PRE_STATE",
    POST_STATE = "POST_STATE",
}

export enum HalfcardVariants {
    DEFAULT = "DEFAULT",
    NEW = "NEW",
}

export interface TGLogoCTX {
    text: string;
    logo: string;
    lottie?: string;
}

export interface CTA {
    link: string;
    type: string;
    text: string;
}

export interface BottomSheetData {
    logoCtx: TGLogoCTX;
    contentImage?: string;
    title: string;
    subtitles?: string[];
    ctas: CTA[];
    content?: Content[];
    note?: string;
    attributeValues: Record<string, string>;
    designVariantId?: HalfcardVariants;
    isOneLite?: boolean;
    identifiers?: M2cIdentifiers;
    assetCtx?: AssetCtx[];
}

export interface PreStateData {
    bottomSheetData: BottomSheetData;
    addSuperFromTGBottomsheet: (ctaText: string) => void;
    closeBottomSheet?: (ctaText: string) => void;
}

export interface PostStateData {
    headerText: string;
    logoCtx: TGLogoCTX;
    title: string;
    closeBottomSheet?: (ctaText: string) => void;
    setIsM2CGratificationShown?: (v: boolean) => void;
    duration?: number;
    subTitles?: string[];
    content?: Content[];
    attributeValues?: Record<string, string>;
    cta?: TGCTAs;
}

export interface M2CSwiggyBlackHalfCardProps {
    preStateData?: PreStateData;
    postStateData?: PostStateData;
    state?: States;
    root?: string;
    onClose?: VoidFunction;
}
